<template>
    <div>
      <p>CODIGO AUTOSAT: <strong>{{ crcResult }}</strong></p>
    </div>
  </template>
  
  <script>
  export default {
    name: "autosat",
  
    data() {
      return {
        currentDate: null, 
        crcResult: 'Retrieving data....',
      };
    },
  
    mounted() {
      this.fetchRealTimeDate();
    },
  
    methods: {
      async fetchRealTimeDate() {
        try {
            const randomId = Date.now(); 
            const response = await fetch(`https://europe-west1-hayward-europe.cloudfunctions.net/getServerDate?nocache=${randomId}`);
          const data = await response.json();

          if (!data.date || data.date.length !== 6) {
          crcResult = "Invalid date format from server";
        }

        this.currentDate = data.date;
        this.computeCRC();
        } catch (error) {
          console.error("Error fetching real-time date:", error);
          crcResult = "Error"; 
        }
      },
  
      calculateCRC16(data) {
        let bytes = new TextEncoder().encode(data);
        let crc = 0xffff;
  
        for (let b of bytes) {
          crc ^= b;
          for (let i = 0; i < 8; i++) {
            if (crc & 1) {
              crc = (crc >> 1) ^ 0xa001;
            } else {
              crc >>= 1;
            }
          }
        }
  
        return crc.toString(16).toUpperCase().padStart(4, "0");
      },
  
      computeCRC() {
        if (this.currentDate) {
          this.crcResult = this.calculateCRC16(this.currentDate);
        }
      },
    },
  };
  </script>
  
  <style scoped>
  p {
    text-align: left;
    font-size: 18px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Autosat.vue